import React from 'react';
import { Helmet } from 'react-helmet-async';

const SntPage = () => {
  const handleAccordion = (e: React.MouseEvent<HTMLDivElement>) => {
    const header = e.currentTarget;
    const content = header.nextElementSibling as HTMLElement;
    const icon = header.querySelector('i');
    if (content && icon) {
      content.classList.toggle('active');
      icon.style.transform = content.classList.contains('active')
        ? 'rotate(180deg)'
        : 'rotate(0deg)';
    }
  };

  return (
    <>
      <Helmet>
        <title>КТПН для СНТ — электроснабжение садового товарищества под ключ</title>
      </Helmet>
      <main>
        <section className="bg-[#f9fcff] py-16">
          <div className="container mx-auto px-7">
            <div className="flex flex-wrap gap-12 items-center">
              <div className="flex-1">
                <h1 className="text-5xl font-semibold text-[#1a3a4f]">
                  КТПН для СНТ: готовое решение электроснабжения садового товарищества
                </h1>
                <p className="text-lg text-[#2c5a7a] mt-5">
                  Как запитать дачный посёлок, кооператив или коттеджный массив. Расчёт нагрузки,
                  подбор подстанции, монтаж под ключ и сезонная эксплуатация.
                </p>
                <div className="flex flex-wrap gap-4 my-6">
                  <span className="bg-white text-sm font-medium px-4 py-2 rounded-full border border-gray-200 shadow-sm">
                    <i className="fas fa-tree"></i> Для СНТ и дач
                  </span>
                  <span className="bg-white text-sm font-medium px-4 py-2 rounded-full border border-gray-200 shadow-sm">
                    <i className="fas fa-charging-station"></i> Модельный расчёт
                  </span>
                  <span className="bg-white text-sm font-medium px-4 py-2 rounded-full border border-gray-200 shadow-sm">
                    <i className="fas fa-file-alt"></i> Под ключ
                  </span>
                </div>
                <div className="flex flex-wrap gap-4 mt-8">
                  <a
                    href="#requestForm"
                    className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-white bg-[#1e4a6e] hover:bg-[#0f3550]"
                  >
                    <i className="fas fa-file-invoice"></i> Запросить расчёт для СНТ
                  </a>
                  <a
                    href="#"
                    className="inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-[#1e4a6e] bg-[#f0f4f8] hover:bg-[#e6edf4] border border-[#cbdde9]"
                  >
                    <i className="fas fa-download"></i> Скачать опросный лист
                  </a>
                </div>
              </div>
              <div className="flex-none w-full md:w-2/5">
                <img
                  src="https://images.pexels.com/photos/2047924/pexels-photo-2047924.jpeg?auto=compress&cs=tinysrgb&w=800"
                  alt="КТПН для СНТ"
                  className="rounded-2xl shadow-lg"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 border-b border-gray-100">
          <div className="container mx-auto px-7">
            <h2 className="text-3xl font-semibold relative inline-block after:content-[''] after:absolute after:bottom-[-8px] after:left-0 after:w-16 after:h-1 after:bg-blog-accent after:rounded">
              Основные проблемы электроснабжения СНТ и дачных посёлков
            </h2>
            <div className="bg-[#f8fafd] border-l-4 border-blog-accent rounded-2xl p-8 my-8">
              <ul className="grid grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-4">
                <li className="flex items-center gap-3">
                  <i className="fas fa-bolt text-blog-accent"></i> Сезонные скачки нагрузки
                  (весна‑осень)
                </li>
                <li className="flex items-center gap-3">
                  <i className="fas fa-chart-line text-blog-accent"></i> Старые столбовые
                  трансформаторы
                </li>
                <li className="flex items-center gap-3">
                  <i className="fas fa-arrow-up text-blog-accent"></i> Низкое напряжение в сети
                </li>
                <li className="flex items-center gap-3">
                  <i className="fas fa-hand-holding-usd text-blog-accent"></i> Ограниченный бюджет
                  товарищества
                </li>
                <li className="flex items-center gap-3">
                  <i className="fas fa-file-invoice text-blog-accent"></i> Сложности с учётом
                  электроэнергии
                </li>
                <li className="flex items-center gap-3">
                  <i className="fas fa-shield-alt text-blog-accent"></i> Отсутствие заземления и
                  защиты
                </li>
              </ul>
            </div>
            <p>
              Типичное решение — установка собственной комплектной трансформаторной подстанции
              (КТПН) с учётом сезонного потребления и возможностью удалённого снятия показаний.
            </p>
          </div>
        </section>

        <section className="py-16 border-b border-gray-100">
          <div className="container mx-auto px-7">
            <h2 className="text-3xl font-semibold relative inline-block after:content-[''] after:absolute after:bottom-[-8px] after:left-0 after:w-16 after:h-1 after:bg-blog-accent after:rounded">
              Этапы реализации проекта для СНТ
            </h2>
            <div className="grid md:grid-cols-5 gap-6 my-8">
              <div className="text-center">
                <div className="bg-blog-accent text-white w-10 h-10 rounded-full inline-flex items-center justify-center font-bold mb-4">
                  1
                </div>
                <h3 className="font-semibold text-lg">Выезд инженера</h3>
                <p className="text-sm text-gray-600">Оценка нагрузок, сетей, места установки.</p>
              </div>
              <div className="text-center">
                <div className="bg-blog-accent text-white w-10 h-10 rounded-full inline-flex items-center justify-center font-bold mb-4">
                  2
                </div>
                <h3 className="font-semibold text-lg">Подбор оборудования</h3>
                <p className="text-sm text-gray-600">Расчёт мощности, выбор КТПН, щита учёта.</p>
              </div>
              <div className="text-center">
                <div className="bg-blog-accent text-white w-10 h-10 rounded-full inline-flex items-center justify-center font-bold mb-4">
                  3
                </div>
                <h3 className="font-semibold text-lg">Изготовление</h3>
                <p className="text-sm text-gray-600">15–20 рабочих дней, включая корпус IP54.</p>
              </div>
              <div className="text-center">
                <div className="bg-blog-accent text-white w-10 h-10 rounded-full inline-flex items-center justify-center font-bold mb-4">
                  4
                </div>
                <h3 className="font-semibold text-lg">Монтаж</h3>
                <p className="text-sm text-gray-600">Установка, подключение, заземление.</p>
              </div>
              <div className="text-center">
                <div className="bg-blog-accent text-white w-10 h-10 rounded-full inline-flex items-center justify-center font-bold mb-4">
                  5
                </div>
                <h3 className="font-semibold text-lg">Пусконаладка</h3>
                <p className="text-sm text-gray-600">Испытания, настройка, выдача протоколов.</p>
              </div>
            </div>
          </div>
        </section>

        <section id="requestForm" className="bg-[#fafdfe] py-16">
          <div className="container mx-auto px-7">
            <div className="bg-white rounded-3xl p-10 shadow-lg max-w-3xl mx-auto">
              <h2 className="text-3xl font-semibold mb-2 text-center">
                Рассчитайте электроснабжение вашего СНТ
              </h2>
              <p className="text-center text-gray-600 mb-8">
                Инженер «ПромИннова» подготовит расчёт мощности, подбор оборудования и КП за 2 дня.
              </p>
              <form>
                <div className="grid grid-cols-2 gap-6 mb-6">
                  <input
                    type="text"
                    placeholder="Имя *"
                    required
                    className="p-3 border border-gray-300 rounded-full"
                  />
                  <input
                    type="text"
                    placeholder="Телефон *"
                    required
                    className="p-3 border border-gray-300 rounded-full"
                  />
                </div>
                <div className="mb-6">
                  <input
                    type="email"
                    placeholder="Email *"
                    required
                    className="w-full p-3 border border-gray-300 rounded-full"
                  />
                </div>
                <div className="mb-6">
                  <textarea
                    placeholder="Количество участков, мощность на участок..."
                    rows={4}
                    className="w-full p-3 border border-gray-300 rounded-2xl"
                  ></textarea>
                </div>
                <div className="mb-6 bg-yellow-50 border-dashed border-blog-accent border-2 p-4 rounded-2xl text-center">
                  <label
                    htmlFor="file-upload"
                    className="cursor-pointer text-blog-accent font-semibold"
                  >
                    <i className="fas fa-paperclip"></i> Приложите схему СНТ или опросный лист *
                  </label>
                  <input id="file-upload" type="file" className="hidden" />
                </div>
                <div className="text-center">
                  <button
                    type="submit"
                    className="inline-flex items-center gap-2 px-8 py-3 rounded-full font-semibold text-white bg-[#1e4a6e] hover:bg-[#0f3550]"
                  >
                    <i className="fas fa-paper-plane"></i> Получить расчёт и КП
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>

        <section className="py-16">
          <div className="container mx-auto px-7">
            <h2 className="text-3xl font-semibold relative inline-block after:content-[''] after:absolute after:bottom-[-8px] after:left-0 after:w-16 after:h-1 after:bg-blog-accent after:rounded">
              Часто задаваемые вопросы
            </h2>
            <div className="mt-8 max-w-4xl mx-auto">
              <div className="border-b border-gray-200 py-4">
                <div
                  onClick={handleAccordion}
                  className="cursor-pointer flex justify-between items-center font-semibold text-lg"
                >
                  Можно ли установить КТПН без ограждения?
                  <i className="fas fa-chevron-down transition-transform"></i>
                </div>
                <div className="hidden mt-2 text-gray-600">
                  Да, при степени защиты корпуса IP54 и запираемых дверях ограждение не требуется по
                  ПУЭ (п. 4.2.26). Однако для защиты от наезда транспорта может потребоваться
                  отбойник.
                </div>
              </div>
              {/* ... more FAQ items ... */}
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default SntPage;
